export default __webpack_public_path__ + "images/The-Wildlife-Trust.jpg";